import { Grid } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'
import { CustomList } from '../../../../components/Display/Lists'
import { BuildingInfoDisplay, buildingInfoOrder } from '../utils/dataHandling'

interface ApartmentInformationListProps {
  apartmentInformation: BuildingInfoDisplay
  t: i18n.TFunction
}

const ApartmentInformationList: FC<ApartmentInformationListProps> = ({
  apartmentInformation,
  t
}) => (
  <Grid container direction='column' item xs={12} justify='space-between'>
    <CustomList
      t={t}
      translationPath='apartment.list.information.'
      data={apartmentInformation}
      informationOrder={buildingInfoOrder}
    />
  </Grid>
)

export default ApartmentInformationList
